import "core-js/modules/es.array.push.js";
export default {
  data() {
    return {
      sqlInput: "",
      jsonInput: ""
    };
  },
  methods: {
    // SQL 转 JSON 逻辑
    sqlToJson() {
      try {
        const tableDefinition = this.sqlInput.split("\n").filter(line => line.trim().startsWith("`"));
        const jsonArray = [];
        tableDefinition.forEach(line => {
          const match = line.match(/`([^`]*)`\s+[^`]+/);
          if (match && match[1]) {
            jsonArray.push({
              [match[1]]: ""
            });
          }
        });
        this.jsonInput = JSON.stringify(jsonArray, null, 2);
      } catch (error) {
        alert("SQL 格式解析错误，请检查输入内容！");
      }
    },
    // JSON 转 SQL 逻辑
    jsonToSql() {
      try {
        const jsonArray = JSON.parse(this.jsonInput);
        if (!Array.isArray(jsonArray)) {
          throw new Error("JSON 内容必须是数组格式");
        }
        let sql = "CREATE TABLE `converted_table` (\n";
        jsonArray.forEach((item, index) => {
          const key = Object.keys(item)[0];
          sql += `  \`${key}\` varchar(255) COLLATE utf8_unicode_ci NOT NULL`;
          if (index < jsonArray.length - 1) {
            sql += ",\n";
          }
        });
        sql += "\n)";
        this.sqlInput = sql;
      } catch (error) {
        alert(`JSON 解析错误：${error.message}`);
      }
    },
    // 清空输入框
    clearInputs() {
      this.sqlInput = "";
      this.jsonInput = "";
    }
  }
};